"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseUpload = BaseUpload;
exports.BaseUploadCard = BaseUploadCard;
exports.getFileExtension = exports.UploadStatus = exports.SelectType = exports.FileType = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _upload = _interopRequireDefault(require("../../assets/images/upload.svg"));
var _uploadDisabled = _interopRequireDefault(require("../../assets/images/upload-disabled.svg"));
var _photo = _interopRequireDefault(require("../../assets/images/photo.svg"));
var _gallery = _interopRequireDefault(require("../../assets/images/gallery.svg"));
var _folder = _interopRequireDefault(require("../../assets/images/folder.svg"));
var _camera = _interopRequireDefault(require("../../assets/images/camera.svg"));
var _delete = _interopRequireDefault(require("../../assets/images/delete.svg"));
var _retry = _interopRequireDefault(require("../../assets/images/retry.svg"));
var _file_csv = _interopRequireDefault(require("../../assets/images/file_csv.svg"));
var _file_doc = _interopRequireDefault(require("../../assets/images/file_doc.svg"));
var _file_docx = _interopRequireDefault(require("../../assets/images/file_docx.svg"));
var _file_pdf = _interopRequireDefault(require("../../assets/images/file_pdf.svg"));
var _file_xls = _interopRequireDefault(require("../../assets/images/file_xls.svg"));
var _file_xlsm = _interopRequireDefault(require("../../assets/images/file_xlsm.svg"));
var _file_xlsx = _interopRequireDefault(require("../../assets/images/file_xlsx.svg"));
var _file_default = _interopRequireDefault(require("../../assets/images/file_default.svg"));
var _Popover = require("../Popover");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _LocaleProvider = require("../LocaleProvider");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var SelectType;
exports.SelectType = SelectType;
(function (SelectType) {
  SelectType[SelectType["Gallery"] = 0] = "Gallery";
  SelectType[SelectType["Photos"] = 1] = "Photos";
  SelectType[SelectType["File"] = 2] = "File";
})(SelectType || (exports.SelectType = SelectType = {}));
var FileType;
exports.FileType = FileType;
(function (FileType) {
  FileType[FileType["File"] = 1] = "File";
  FileType[FileType["Image"] = 2] = "Image";
  FileType[FileType["Video"] = 3] = "Video";
})(FileType || (exports.FileType = FileType = {}));
var UploadStatus;
exports.UploadStatus = UploadStatus;
(function (UploadStatus) {
  UploadStatus[UploadStatus["Loading"] = 0] = "Loading";
  UploadStatus[UploadStatus["Fail"] = 1] = "Fail";
  UploadStatus[UploadStatus["Success"] = 2] = "Success";
})(UploadStatus || (exports.UploadStatus = UploadStatus = {}));
var FileSelectConfig = [{
  type: SelectType.Photos,
  textKey: 'probing_form_photo_library',
  icon: _photo.default
}, {
  type: SelectType.Gallery,
  textKey: 'probing_form_take_photo_or_video',
  icon: _gallery.default
}, {
  type: SelectType.File,
  textKey: 'probing_form_choose_files',
  icon: _folder.default
}];
function BaseUpload(props) {
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var maxCount = props.maxCount;
  var disabled = props.fileList.length >= maxCount;
  var onSelectBtnClick = function onSelectBtnClick(type) {
    props.handleUpload(type);
  };
  var anchorRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('base-upload')
  }, props.fileList.length !== 0 && props.showPreviewList && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('card-list')
  }, props.fileList.map(function (file, index) {
    return /*#__PURE__*/_react.default.createElement(BaseUploadCard, {
      key: index,
      file: file,
      onRemove: function onRemove() {
        var _props$onRemove;
        return (_props$onRemove = props.onRemove) === null || _props$onRemove === void 0 ? void 0 : _props$onRemove.call(props, index);
      },
      onRetry: function onRetry() {
        var _props$onRetry;
        return (_props$onRetry = props.onRetry) === null || _props$onRetry === void 0 ? void 0 : _props$onRetry.call(props, file.originFile, index);
      }
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('upload-btn', {
      disabled: disabled
    }),
    ref: anchorRef
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: disabled ? _uploadDisabled.default : _upload.default
  }), trans('probing_form_click_to_upload'), " (", props.fileList.length, "/", props.maxCount, ")"), !disabled && /*#__PURE__*/_react.default.createElement(_Popover.Popover, {
    anchorRef: anchorRef,
    clickSelfClose: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('file-select-list')
  }, FileSelectConfig.map(function (v, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      onClick: function onClick() {
        return onSelectBtnClick(v.type);
      }
    }, trans(v.textKey), /*#__PURE__*/_react.default.createElement("img", {
      src: v.icon
    }));
  }))));
}
var FILE_ICON = {
  FileIconCSV: _file_csv.default,
  FileIconDOC: _file_doc.default,
  FileIconDOCX: _file_docx.default,
  FileIconPDF: _file_pdf.default,
  FileIconXLS: _file_xls.default,
  FileIconXLSM: _file_xlsm.default,
  FileIconXLSX: _file_xlsx.default
};
var getFileExtension = function getFileExtension(filename) {
  var _filename$split, _filename$split$pop;
  return filename === null || filename === void 0 ? void 0 : (_filename$split = filename.split('.')) === null || _filename$split === void 0 ? void 0 : (_filename$split$pop = _filename$split.pop()) === null || _filename$split$pop === void 0 ? void 0 : _filename$split$pop.toUpperCase();
};
exports.getFileExtension = getFileExtension;
function BaseUploadCard(props) {
  var _useLocale2 = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale2.trans;
  var _props$file = props.file,
    status = _props$file.status,
    originFile = _props$file.originFile;
  var getPreviewElement = function getPreviewElement() {
    var _props$file2 = props.file,
      type = _props$file2.type,
      url = _props$file2.url,
      coverUrl = _props$file2.coverUrl,
      duration = _props$file2.duration,
      name = _props$file2.name,
      status = _props$file2.status;
    if (type === FileType.File) {
      var fileType = getFileExtension(name);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "card-file-item"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: FILE_ICON["FileIcon".concat(fileType === null || fileType === void 0 ? void 0 : fileType.toUpperCase())] || _file_default.default
      }), /*#__PURE__*/_react.default.createElement("span", null, name));
    } else if (type === FileType.Video) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
        className: "cover-img",
        src: coverUrl
      }), status !== UploadStatus.Loading && /*#__PURE__*/_react.default.createElement("div", {
        className: "video-footer"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _camera.default
      }), /*#__PURE__*/_react.default.createElement("span", null, duration)));
    } else if (type === FileType.Image) {
      return /*#__PURE__*/_react.default.createElement("img", {
        className: "cover-img",
        src: url !== null && url !== void 0 ? url : coverUrl
      });
    } else {
      return null;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('card-item')
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick() {
      var _props$onPreview;
      return (_props$onPreview = props.onPreview) === null || _props$onPreview === void 0 ? void 0 : _props$onPreview.call(props, props.file);
    }
  }, getPreviewElement()), status === UploadStatus.Fail && /*#__PURE__*/_react.default.createElement("div", {
    className: "fail"
  }, /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("img", {
    src: _retry.default,
    onClick: function onClick() {
      var _props$onRetry2;
      return (_props$onRetry2 = props.onRetry) === null || _props$onRetry2 === void 0 ? void 0 : _props$onRetry2.call(props, originFile);
    }
  }), /*#__PURE__*/_react.default.createElement("span", null, trans('probing_form_upload_retry'))), props.showRemoveIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: "delete-btn",
    onClick: function onClick() {
      var _props$onRemove2;
      return (_props$onRemove2 = props.onRemove) === null || _props$onRemove2 === void 0 ? void 0 : _props$onRemove2.call(props);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _delete.default
  })), /*#__PURE__*/_react.default.createElement(Progressbar, {
    status: status !== null && status !== void 0 ? status : UploadStatus.Success,
    key: status
  }));
}
function Progressbar(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    moveForward = _useState2[0],
    setMoveForward = _useState2[1];
  setTimeout(function () {
    setMoveForward(true);
  }, 500);
  var status = props.status;
  if (status !== UploadStatus.Loading) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-bar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('percent', {
      forward: moveForward
    })
  }));
}